import { Fade } from "@mui/material";
import { ReactNode } from "react";
import goodDesignLogo from "../../../../assets/images/LandingPage/GoodDesignAward/good-design.png";
import AnimationController from "../../../../components/AnimationController/AnimationController";
import styles from "./index.module.scss";

interface AwardCardProps {
    variant: "afr" | "goodDesign";
    logo: ReactNode;
    description: string;
    href: string;
    linkText: string;
}

const AwardCard = ({ variant, logo, description, href, linkText }: AwardCardProps) => (
    <article className={`${styles.card} ${styles[variant]}`}>
        <svg className={styles.background} viewBox="0 0 616 473" preserveAspectRatio="none" aria-hidden="true" focusable="false">
            {variant === "afr" ? (
                <>
                    <path d="M250 0C80 100 170 254 616 257V0Z" />
                    <path d="M0 388Q300 473 616 464V473H0Z" />
                </>
            ) : (
                <path d="M0 252C180 214 360 207 616 213V367C350 347 245 403 0 463Z" />
            )}
        </svg>
        <div className={styles.logo}>{logo}</div>
        <p className={styles.description}>{description}</p>
        <a className={styles.link} href={href} target="_blank" rel="noopener noreferrer">
            {linkText}<span className={styles.arrow} aria-hidden="true">→</span>
        </a>
    </article>
);

const AwardCards = () => (
    <AnimationController
        render={(loadedAnimation) => (
            <Fade in={loadedAnimation} timeout={1000}>
                <section className={styles.awards} aria-label="Awards and recognition">
                    <AwardCard
                        variant="afr"
                        logo={
                            <svg className={styles.afrLogo} viewBox="0 0 484 80" role="img" aria-label="Financial Review">
                                <text x="0" y="66" textLength="484" lengthAdjust="spacingAndGlyphs">FINANCIAL REVIEW</text>
                            </svg>
                        }
                        description="Kepple ranked 13th among Australia’s fastest-growing young companies in the Australian Financial Review’s 2024 Fast Starters list."
                        href="https://www.afr.com/companies/financial-services/revealed-australia-s-fastest-growing-companies-in-2024-20241122-p5ksvk"
                        linkText="Read more in the AFR"
                    />
                    <AwardCard
                        variant="goodDesign"
                        logo={<img className={styles.goodDesignLogo} src={goodDesignLogo} alt="Good Design Award Winner" />}
                        description="Spark received a 2026 Australian Good Design Award for helping schools find relief staff faster and giving educators more control over work."
                        href="https://good-design.org/projects/spark-relief-teachers/"
                        linkText="Read about the award"
                    />
                </section>
            </Fade>
        )}
        customThreshold={0.15}
        animationCanReplay={false}
    />
);

export default AwardCards;
